export default "/images/db2973a5627205095c273d433e665620.avif";